import React, { useCallback } from 'react';

import { LargeMenuItem, List, MenuDivider, Popover } from '@lyearn/ui';
import { usePopoverContext } from '@lyearn/ui';

import { LargeActionMenuItemProps, LargeActionMenuProps } from './types';

function LargeActionMenuItem(props: LargeActionMenuItemProps) {
  const { onClose } = usePopoverContext();
  const { onAction, item, ...rest } = props;

  const onClick = useCallback(() => {
    onAction?.(item.id, item);
    onClose();
  }, [item, onAction, onClose]);

  return <LargeMenuItem onClick={onClick} {...item} {...rest} />;
}

function LargeActionMenu(
  props: LargeActionMenuProps & { open?: boolean; onOpenChange?: (open: boolean) => void },
) {
  const { children, items, minWidth, maxWidth, position, onAction, open, onOpenChange } = props;

  if (!items.length) {
    return null;
  }

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <Popover.Button>{children}</Popover.Button>
      <Popover.Content maxWidth={maxWidth} minWidth={minWidth} position={position}>
        <List className="flex flex-col space-y-8 py-12 px-8">
          {items.map((item, index) => {
            switch (item.type) {
              case 'divider':
                return <MenuDivider key={`MenuDivider-${index}`} {...item} />;
              case 'item':
              default:
                return (
                  <LargeActionMenuItem
                    key={item.id}
                    autoFocus={index === 0}
                    data-action={item.id}
                    item={item}
                    onAction={onAction}
                  />
                );
            }
          })}
        </List>
      </Popover.Content>
    </Popover>
  );
}

export default LargeActionMenu;
